import { Controller } from "@hotwired/stimulus";
import { useStore } from "stimulus-store";
import { facilitySelectionStore } from "../stores/facility_selection_store";
import _ from "lodash";
import {
    LOCALE_TYPE_AREA,
    LOCALE_TYPE_BUILDING,
    LOCALE_TYPE_REGION,
    LOCALE_TYPE_ROOM
} from "constants/facilities_constants";
import { getCurrentlyDisplayedFacilityType } from "../stores/helpers/facility_helpers";


// Connects to facilities-breadcrumb
export default class extends Controller {
    static targets = ["breadcrumbList"];
    static stores = [facilitySelectionStore]

    connect() {
        // Subscribe this controller to the stores in the stores array.
        useStore(this);
    }

    onFacilitySelectionStoreUpdate(selectedFacilities) {
        // Remove all the breadcrumbs. This simplifies this implementations since we can use the
        // same logic to update the breadcrumbs regardless of whether the user went back or
        // drilled deeper
        this._removeAllBreadcrumbs();

        // For each selected locale type, append a breadcrumb
        [LOCALE_TYPE_REGION, LOCALE_TYPE_BUILDING, LOCALE_TYPE_AREA, LOCALE_TYPE_ROOM].forEach(localeType => {
            if (!_.isEmpty(selectedFacilities[localeType].id)) {
                this._appendSelectedFacilityBreadcrumb(localeType, selectedFacilities[localeType].id, selectedFacilities[localeType].name, true);
            }
        });

        // Add a breadcrumb to the end of the list that tells the user what they're currently viewing
        this._appendCurrentlyViewingBreadcrumb(selectedFacilities);
    }

    _removeAllBreadcrumbs() {
        this.breadcrumbListTarget.replaceChildren(); // Removes all child elements
    }

    _appendSelectedFacilityBreadcrumb(localeType, localeId, localeName, isActive) {
        // Create the new breadcrumb
        const li = document.createElement('li');
        li.className = 'breadcrumb-item';
        li.textContent = `${_.capitalize(localeType)}: ${localeName}`;

        // Add it to the end of the breadcrumb list
        this.breadcrumbListTarget.appendChild(li);
    }

    _appendCurrentlyViewingBreadcrumb(selectedFacilities) {
        // Grab the locale type the table is currently displaying
        const localeType = getCurrentlyDisplayedFacilityType(selectedFacilities);

        // Create the new breadcrumb
        const li = document.createElement('li');
        li.className = 'breadcrumb-item';
        li.textContent = `${_.capitalize(localeType)}s`;

        // Add it to the end of the breadcrumb list
        this.breadcrumbListTarget.appendChild(li);
    }

}